import { render } from "./C.vue?vue&type=template&id=1d915843"
import script from "./C.vue?vue&type=script&lang=js"
export * from "./C.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__